export const COOKIE_PAGE_SIZE = 'pageSize';
export const LANDING_SESSION_COOKIE = 'landingSession';
export const PDP_FIRST_VIEW = 'pdpFirstView';
